import { isDefined, tryCatch } from "@opendaw/lib-std";
import { PreferencesFacade } from "./PreferencesFacade";
import { PreferencesHost } from "./PreferencesHost";
export var Preferences;
(function (Preferences) {
    Preferences.host = (key, zod) => {
        const facade = new PreferencesHost(loadFromStorage(key, zod));
        facade.subscribeAll(() => tryCatch(() => localStorage.setItem(key, JSON.stringify(facade.settings))));
        return facade;
    };
    Preferences.facade = (key, zod) => {
        const facade = new PreferencesFacade(loadFromStorage(key, zod));
        facade.subscribeAll(() => tryCatch(() => localStorage.setItem(key, JSON.stringify(facade.settings))));
        return facade;
    };
    const loadFromStorage = (key, zod) => {
        const stored = localStorage.getItem(key);
        if (isDefined(stored)) {
            const { status, value } = tryCatch(() => JSON.parse(stored));
            if (status === "success") {
                const result = zod.safeParse(value);
                if (result.success) {
                    return result.data;
                }
            }
        }
        return zod.parse({});
    };
})(Preferences || (Preferences = {}));
